module.exports = __webpack_public_path__ + "static/media/spotify-original.2c0a238d.svg";